import { render, staticRenderFns } from "./savings_redeem.vue?vue&type=template&id=3b120cdd&scoped=true"
import script from "./savings_redeem.vue?vue&type=script&lang=js"
export * from "./savings_redeem.vue?vue&type=script&lang=js"
import style0 from "./savings_redeem.vue?vue&type=style&index=0&id=3b120cdd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b120cdd",
  null
  
)

export default component.exports